import { appStore } from '../../app/AppStore';
import { Module } from '../Module';

interface IAppAdminStateScope extends ng.IScope {
  displayDefault: boolean;
}

Module.instance().directive('tbApp', [
  () => {
    return ({
      restrict: 'E',
      replace: true,
      template: '<div class="tb-app-inner"><tb:app-inner ng-if="!displayDefault"/><div ng-if="displayDefault" ui-view="" /><div ng-if="displayDefault"><tb:navigation-telemetry /></div></div>',
      scope: {},
      link: (scope: IAppAdminStateScope) => {
        function updateDisplayDefault() {
          const rootAdminUiState = appStore.getState().rootAdminUiState;
          scope.displayDefault = rootAdminUiState === 'default';
        }
        updateDisplayDefault();
        appStore.subscribe(() => {
          updateDisplayDefault();
        });
      }
    });
  }
]);
